<template>
    <div class="main">
        <div class="training">
        <h1>
            Системы организма
        </h1>
        <ul class="trainig_body">
            <v-skeleton-loader v-for="key in 13" :key="'A'+key" width="260" height="258" type="card" v-show="loadingTree" />

            <li
                v-for="(item, key) in tree"
                :key="'B'+key"
                :class="calculateClass(item)"
                v-show="!loadingTree"
                @click="openOrRoute(item)"
            >
                <inline-svg :src="`${apiImg}${item.iconUrl}`" />
                <p>{{ item.name }}</p>
            </li>
        </ul>


        <div v-if="dialog" class="somaticTree">
            <mental-function :treeListM="maleTreeView" :treeListJ="femaleTreeView">
                <template v-slot:btn>
                    <button class="close" @click.prevent="dialog = false">
                        <inline-svg :src="require('../../../assets/img/icons/CloseNew.svg')" />
                    </button>
                </template>
            </mental-function>
        </div>

        <div v-if="dialogSom" class="somaticTree">
            <somatic-status :listSystem="listSystem">
                <template v-slot:btn>
                    <button class="close" @click.prevent="dialogSom = false">
                        <inline-svg :src="require('../../../assets/img/icons/CloseNew.svg')" />
                    </button>
                </template>
            </somatic-status>
        </div>
    </div>
    <div class="training-mob">
        <h1 class="main-header">
            Системы организма
        </h1>
        <div v-show="!loadingTree" class="main-div-card">
            <div class="training-mob-container" @click="openOrRoute(item)" v-for="(item, key) in tree" :key="'B'+key" :class="calculateClass(item)">
                <div class="img">
                    <inline-svg :src="`${apiImg}${item.iconUrl}`" />
                </div>
                <div style="width: 60%;">
                    <span class="text-title-mobile">{{ item.name }}</span>
                </div>
                <div class="div-svg">
                    <inline-svg class="cursor-pointer" :src="require('@/assets/img/icons/ArrowRight.svg')" />
                </div>
            </div>
            <div v-if="dialog"  class="psyhic-function-mobile">
                <MobileMentalFunction @dialog='dialog = false' :treeListM="maleTreeView" :treeListJ="femaleTreeView">
                </MobileMentalFunction>
            </div>
            <div v-if="dialogSom" :style="dialogSom ? 'height: 5000px' : ' '" class="somatic-status-mobile">
                <SomaticStatusMobile @dialog='dialogSom = false' :listSystem="listSystem">
                </SomaticStatusMobile>
            </div>
        </div>
    </div>
</div>

</template>

<script>
import InlineSvg from 'vue-inline-svg';
import { mapGetters, mapActions } from 'vuex'
import mentalFunction from '../MentalFunctions/index.vue'
import MobileMentalFunction from '../MobileMentalFunction/index.vue'
import somaticStatus from '../SomaticStatus/index.vue'
import SomaticStatusMobile from '../SomaticStatusMobile/index.vue'
import "./index.scss";

export default {
    name: 'Training',
    components: {
        InlineSvg,
        mentalFunction,
        somaticStatus,
        MobileMentalFunction,
        SomaticStatusMobile
    },
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl',
            apiImg: 'apiImg',
            apiGuide: 'apiGuide',
            gendersList: 'property/genders',
        })
    },
    data: () => ({
        listSystem: [],
        maleTreeView: [],
        femaleTreeView: [],
        tree: [],
        loadingTree: true,
        dialog: false,
        dialogSom: false
    }),
    methods: {
		...mapActions({
			getGenders: 'property/getGenders'
		}),
        getTree() {
            this.loadingTree = true;

            this.$http.get(`${this.apiUrl}BodyTree/GetTreeView?humanid=0B12F2AB-2702-4FD6-B83C-0E8CA38A9628`)
                .then((res) => {
                    // Вшить "Соматический статус" и "Показатели психических функций" в список
                    res.data[0].children.push({
                        id: '00000000-0000-0000-0000-000000000013',
                        name: 'Соматический статус',
                        iconUrl: '/files/icons/soms.svg'
                    },
                    {
                        id: '00000000-0000-0000-0000-000000000011',
                        name: 'Показатели психических функций',
                        iconUrl: '/files/icons/ppf.svg'
                    })
                    this.loadingTree = false;
                    this.tree = res.data[0].children
                })
                .catch((error) => {
                    if(error) {
                        this.loadingTree = false;
                    }
                })
        },
        getPsychicFunc() {
            this.$http
                .post(`${this.apiUrl}Dictionary/GetPsychicFunctions`, [0, 2])
                .then((res) => {
                    this.maleTreeView = res.data
                })

            this.$http
                .post(`${this.apiUrl}Dictionary/GetPsychicFunctions`, [1, 2])
                .then((res) => {
                    this.femaleTreeView = res.data
                })
        },
        getSomStat() {
            this.$http.post(`${this.apiUrl}Dictionary/GetSomaticStatuses`, [1, 2])
                .then((res) => {
                    // Добавить Антропометрические показатели, Витальные показатели, Лабораторные исследования
                    res.data.unshift(
                        { id: null, name: 'Антропометрические показатели', ord: 0, icon: 'ap.svg' },
                        { id: null, name: 'Витальные показатели', ord: 1, icon: 'v.svg' },
                        { id: null, name: 'Лабораторные исследования', ord: 2, icon: 'li.svg' }
                    )

                    for (let i = 0; i < res.data.length; i++) {
                        if(res.data[i].name === 'Репродуктивная система') {
                            res.data[i].ord = 3
                            res.data[i].icon = 'rs.svg'
                        }
                        if(res.data[i].name === 'Дыхательная система') {
                            res.data[i].ord = 4
                            res.data[i].icon = 'ds.svg'
                        }
                        if(res.data[i].name === 'Лимфатическая система') {
                            res.data[i].ord = 5
                            res.data[i].icon = 'ls.svg'
                        }
                        if(res.data[i].name === 'Нервная система') {
                            res.data[i].ord = 6
                            res.data[i].icon = 'ns.svg'
                        }
                        if(res.data[i].name === 'Мочевая система') {
                            res.data[i].ord = 7
                            res.data[i].icon = 'ms.svg'
                        }
                        if(res.data[i].name === 'Эндокринная система') {
                            res.data[i].ord = 8
                            res.data[i].icon = 'es.svg'
                        }
                        if(res.data[i].name === 'Костно-мышечная система') {
                            res.data[i].ord = 9
                            res.data[i].icon = 'oda.svg'
                        }
                        if(res.data[i].name === 'Сердечно-сосудистая система') {
                            res.data[i].ord = 10
                            res.data[i].icon = 'sss.svg'
                        }
                        if(res.data[i].name === 'Пищеварительная система') {
                            res.data[i].ord = 11
                            res.data[i].icon = 'ps.svg'
                        }
                        if(res.data[i].name === 'Сенсорная система') {
                            res.data[i].ord = 12
                            res.data[i].icon = 'ss.svg'
                        }
                        if(res.data[i].name === 'Покровная система') {
                            res.data[i].ord = 13
                            res.data[i].icon = 'poks.svg'
                        }
                        if(res.data[i].name === 'Иммунная система') {
                            res.data[i].ord = 14
                            res.data[i].icon = 'is.svg'
                        }
                        if(res.data[i].name === 'Кроветворная система (кровь и органы кроветворения)') {
                            res.data[i].ord = 15
                            res.data[i].icon = 'blood.svg'
                        }

                    }
                    this.listSystem = this.sortArray(res.data, 'ord');
                })
        },
        openOrRoute(item) {
            if(item.id === '00000000-0000-0000-0000-000000000011') {
                this.dialog = true;
                window.scrollTo(0, 0);
                return;
            }

            if(item.id === '00000000-0000-0000-0000-000000000013') {
                this.dialogSom = true;
                window.scrollTo(0, 0);
                return;
            }

            if(item.isChildrenExist) this.$router.push({ name: 'SystemTree', params: { id: item.id } })
        },
        sortArray(array, name){
            return array.sort((prev, next) => {
                const nameA = typeof prev[name] === 'string' ? prev[name].toUpperCase() : prev[name];
                const nameB = typeof next[name] === 'string' ? next[name].toUpperCase() : next[name];

                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            })
        },
        calculateClass(item) {
            if(item.name === 'Соматический статус' || item.name === 'Показатели психических функций') return 'body_item'
            if(item.isChildrenExist) return 'body_item'

            return 'body_item_disabled'
        }
    },
    created() {
        this.getTree();
        this.getPsychicFunc();
        this.getSomStat();
    }
}
</script>